import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Menu from './components/Menu';
import ContentArea from './components/ContentArea';
import './styles/App.css';
import { AppStateProvider } from './context/AppStateContext';
import { SettingsProvider } from './context/SettingsContext';
import ManageDataPage from './pages/ManageDataPage';
import Instructions from './pages/Instructions';
import TradingMetricsPage from './pages/TradingMetricsPage';
import Annual from './pages/Annual';
import Monthly from './pages/Monthly';
import Weekly from './pages/Weekly';
import Daily from './pages/Daily';
import EquityGraphs from './pages/EquityGraphs';
import DrawdownGraphs from './pages/DrawdownGraphs';
import TradeList from './pages/TradeList';
import Settings from './pages/Settings';
import Disclaimer from './pages/Disclaimer';
import ThemeWrapper from './ThemeWrapper';
import { LoadingProvider } from './context/LoadingContext';
import { TranslationProvider } from './context/TranslationContext';
import menuConfig from './MenuConfig';
import Header from './components/Header';
import MonthlyGraphs from './pages/MonthlyGraphs';

const App: React.FC = () => {
  return (
    <SettingsProvider>
      <AppStateProvider>
        <TranslationProvider>
          <LoadingProvider>
            <ThemeWrapper>
              <Router>
                <div className="App">
                  <Menu menuConfig={menuConfig} HeaderComponent={Header}/>
                  <ContentArea>
                    <Routes>
                      <Route path="/" element={<Instructions />} />
                      <Route path="/manage-data" element={<ManageDataPage />} />
                      <Route path="/metrics" element={<TradingMetricsPage />} />
                      <Route path="/annual" element={<Annual />} />
                      <Route path="/monthly" element={<Monthly />} />
                      <Route path="/weekly" element={<Weekly />} />
                      <Route path="/daily" element={<Daily />} />
                      <Route path="/equity-graphs" element={<EquityGraphs />} />
                      <Route path="/drawdown-graphs" element={<DrawdownGraphs />} />
                      <Route path="/monthly-graphs" element={<MonthlyGraphs />} />
                      <Route path="/trade-list" element={<TradeList />} />
                      <Route path="/settings" element={<Settings />} />
                      <Route path="/disclaimer" element={<Disclaimer />} />
                    </Routes>
                  </ContentArea>
                </div>
              </Router>
            </ThemeWrapper>
          </LoadingProvider>
        </TranslationProvider>
      </AppStateProvider>
    </SettingsProvider>
  );
}

export default App;
